/**
 * Call Management Type Definitions
 * Local type definitions for the call services module
 */

export type CallState =
  | 'idle'
  | 'dialing'
  | 'ringing'
  | 'connecting'
  | 'connected'
  | 'holding'
  | 'held'
  | 'ending'
  | 'ended'
  | 'post-call'
  | 'failed';

export type CallDirection = 'inbound' | 'outbound';

export type CallDisposition =
  | 'answered'
  | 'no-answer'
  | 'busy'
  | 'failed'
  | 'cancelled'
  | 'rejected'
  | 'system-terminated';

export interface CallSession {
  id: string;
  leadId?: number;
  direction: CallDirection;
  phoneNumber: string;
  startTime: Date;
  endTime?: Date;
  duration?: number;
  state: CallState;
  disposition?: CallDisposition;
  notes?: string;
  recordingUrl?: string;
  telnyxCallId?: string;
  customerCallId?: string;
  agentCallId?: string;
  backendCallId?: number | string;
  status?: string;
}

export interface CallError {
  code: string;
  message: string;
  details?: any;
}
